import React from "react";
import { Badge } from "ui/components/badge";
import { Button } from "ui/components/button";
import { UserFieldInput } from "permissions/components/user-field-input";
import ButtonWithLoading from "@/components/button-with-loading";
import EditItemButton from "components/buttons/edit";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "ui/components/dropdown-menu";
import { MoreVertical, CheckCircle2, XCircle } from "lucide-react";
import { STATUSES } from "@/lib/constants";
import { useUpdateTicket } from "@/modules/support/my-tickets/crud/update/mutation";
import { StatusDisplay } from "@/components/status/display";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";

export default function TicketHeader({
  title,
  status,
  ticketId,
  userCreated,
  assignedTo,
}) {
  const user = useSelector(selectUser);

  const updateTicketMutation = useUpdateTicket();
  const handleStatusUpdate = async (newStatus) => {
    await updateTicketMutation.mutateAsync({
      ticketId,
      values: { status: newStatus },
    });
  };
  return (
    <div className="bg-white border-b">
      <div className="px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="gap-3">
              <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
              <StatusDisplay value={status} />
            </div>
          </div>
          <div>
            <div className="flex items-center gap-2">
              <UserFieldInput
                targetItem={ticketId}
                field="description"
                collection="tickets"
                showWhenDisabled={false}
              >
                <EditItemButton />
              </UserFieldInput>
              {(user.id === userCreated || user.id === assignedTo) && (
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="outline" size="icon">
                      <MoreVertical className="h-4 w-4" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuItem
                      onClick={() => handleStatusUpdate("closed")}
                      disabled={
                        status === "closed" || updateTicketMutation.isLoading
                      }
                    >
                      <XCircle className="h-4 w-4 mr-2" />
                      Close Ticket
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
